export default "__VITE_ASSET__CENo75fs__"